<template>
  <div>
    <!-- 产品信息记录设置 -->
    <baseBreadcrumb :page="$t('message.productInfoRecordSettings')" :menu="$t('message.spotCheck')" />
    <div class="body">
      <div class="tab">
        <div class="tabOpt" :class="{ act: datas.status === item.status }" v-for="(item, index) in listTab" :key="index"
          @click="search(item)">
          {{ item.name }}
          <span v-if="index > 0">({{ item.count }})</span>
        </div>
      </div>
      <div class="search">
        <div class="left">
          <div class="item">
            <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
              range-separator="-" v-model="time" :default-time="['00:00:00', '23:59:59']"
              :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.dateClosed')" clearable>
            </el-date-picker>
          </div>
          <!--任务群体  -->
          <!-- <div class="item"> <el-select v-model="datas.type" :placeholder="$t('message.taskGroup')" clearable
              filterable>
              <el-option v-for="item in options" :key="item.key" :label="item.name" :value="item.key">
              </el-option>
            </el-select></div> -->
          <!--任务群体  -->
          <div class="item">
            <cascader @setUserList="setUserList" :org_id="datas.org_id" ref="cascader" />
          </div>
          <div class="item">
            <!-- 搜索 -->
            <el-button type="primary" @click="search({ status: datas.status })">{{ $t('message.search') }}</el-button>
            <el-button @click="reset">{{ $t('message.reset') }}</el-button>
          </div>
        </div>
        <div class="right">
          <!-- 创建任务 -->
          <el-button type="success" @click="createTask" v-if="isAuth(720)">{{ $t('message.createTask') }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">NO</li>

          <!-- 生效日期 -->
          <li>{{ $t('message.effectiveDate') }}</li>
          <!-- 状态 -->
          <li>{{ $t('message.status') }}</li>
          <!-- 任务群体 -->
          <li>{{ $t('message.taskGroup') }}</li>
          <!-- 执行人-比例-未完成任务数 -->
          <!-- <li>{{ $t('message.executor') }}</li> -->
          <!-- 当前生成条件 -->
          <li class="flex2">{{ $t('message.currentGenerationConditions') }}</li>
          <!-- 操作 -->
          <li class="flex05">{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <!-- 生效日期 -->
          <li>
            <div>
              <p>开始:{{ item.start_at }}</p>
              <p>结束:{{ item.end_at }}</p>
            </div>
          </li>
          <!-- 状态 -->
          <li>
            <el-tag :type="item.status == 1 ? 'success' : 'info'">{{ item.status_name }}</el-tag>
          </li>
          <!-- 任务群体 -->
          <li>
            {{ item.organization.name }}
          </li>
          <!-- 执行人-比例-未完成任务数 -->
          <!-- <li>
            <p v-for="(msg, msgIndex) in item.msg_receive_list" :key="msgIndex">{{ msg.realname }}</p>
          </li> -->
          <!-- 当前生成条件 -->
          <li class="flex2">
            <div class="template">
              <p v-for="(ruleItem, spot_sparkIndex) in item.rule_str_arr" :key="spot_sparkIndex">
                {{ ruleItem }}
              </p>
            </div>
          </li>
          <!-- 操作 -->
          <li class="flex05">
            <router-link :to="'/productInfoRecordDetail?id=' + item.id" target="_blank">
              <el-button type="primary" v-if="isAuth(721)">{{ $t('message.redact') }}</el-button>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      options: [],
      time: [],
      datas: {
        page: 1,
        pageSize: 20,
        type: "",
        start_at: "",
        end_at: "",
        org_id: '',
        status: ''
      },
      options: [],
      tableData: [],
      total: 0,
      listTab: [],
      // 创建任务
      taskType: '',
      dialogVisible: false,
    };
  },
  created() {
    this.$api.spotCheckApi.executeTypeList().then(res => {
      this.options = res.data
    })
    this.$api.spotCheckApi.recordListTab().then(res => {
      // res.data[2].status = 2
      this.listTab = res.data

    })
    this.recordList()

  },
  methods: {

    recordList() {
      if (this.time != false) {
        this.datas.start_at = time[0];
        this.datas.end_at = time[1];
      } else {
        this.datas.start_at = '';
        this.datas.end_at = '';
      }
      this.$api.spotCheckApi.recordList(this.datas).then(res => {
        this.tableData = res.data.data
        this.total = res.data.total
      })
    },
    // 搜索
    search(item) {
      if (item) {
        this.datas.status = item.status
      }
      this.datas.page = 1;
      this.recordList();
    },
    // 重置
    reset() {
      this.datas = {
        page: 1,
        pageSize: 20,
        type: "",
        start_at: "",
        end_at: "",
        status: ''

      };
      this.recordList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.recordList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.recordList();
    },
    //
    setUserList(data) {
      this.datas.org_id = data.id;
    },
    //创建任务
    createTask() {
      let url = this.$router.resolve({
        path: '/productInfoRecordDetail',
      });
      window.open(url.href, "_blank");
    },

  }
}
</script>
<style lang='scss' scoped>
.tab {
  display: flex;
  background: #F8F8F8;
  align-items: center;
  border-bottom: 1px solid #edeff4;
  margin-bottom: 20px;

  .tabOpt {
    height: 50px;
    min-width: 160px;
    padding: 0 30px;
    font-size: 18px;
    line-height: 50px;
    margin-bottom: -2px;
    box-sizing: border-box;
    text-align: center;
    border-top: solid 2px transparent;
    border-bottom: solid 2px transparent;
    cursor: pointer;


  }

  .act {
    color: #b4272d;
    border-top: solid 2px #b4272d;
    border-left: solid 1px #edeff4;
    border-right: solid 1px #edeff4;
    border-bottom: solid 2px #f8f8f8;
    background-color: #f8f8f8;
  }
}

.search {
  display: flex;
  justify-content: space-between;

  .left {
    display: flex;

    .item {
      margin-right: 20px;
    }
  }
}

.table {
  margin-top: 20px;

  ol {
    height: 50px;
  }

  ul {
    padding: 20px 0;
    background-color: #fff;
  }

  .flex05 {
    flex: 0.6;
  }

  .flex2 {
    flex: 2;
  }

  .flex15 {
    flex: 1.5;
  }

  .template {
    width: 100%;
    max-height: 100px;
    overflow: auto;

    p {
      line-height: 22px;
    }
  }
}

.row {
  display: flex;
  padding: 0 10px;

  .label {
    margin-right: 10px;
    line-height: 40px;

    span {
      color: red;
      margin-right: 5px;
    }
  }
}
</style>